import { useState } from 'react'
import { AuthLayout as Layout } from '../layouts'
import { postBetaSignup } from 'actions/api'
import {
  Button,
  Card,
  Center,
  FormInput,
  Link,
  Logo,
  Title,
  Wrapper
} from 'components'

export const BetaSignup = () => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null)

  const submit = () => {
    if (!email) return
    postBetaSignup(email).then((res) => {
      if (res?.beta_signup) {
        setStatus('success')
      } else {
        setStatus('error')
      }
    })
  }

  const handleKeyDown = ({ key }) => {
    if (key === 'Enter') submit()
  }

  if (status === 'success') {
    return (
      <Layout>
        <Card>
          <Wrapper margin="4rem 0">
            <Center>
              <Logo width="250" height="250" />
            </Center>
          </Wrapper>
          <Wrapper margin="0.5rem">
            <Title level={3} color="link">You're on the list!</Title>
          </Wrapper>
          <Wrapper margin="0.5rem">
            We'll email you an invite when it's your turn.
          </Wrapper>
        </Card>
      </Layout>
    )
  }

  return (
    <Layout>
      <Card>
        <Wrapper margin="4rem 0">
          <Center>
            <Logo width="250" height="250" />
          </Center>
        </Wrapper>
        <Wrapper margin="0.5rem">
          <Title level={3} color="link">Join the beta</Title>
        </Wrapper>
        <Wrapper margin="0.5rem">
          Enter your email to get on the waitlist. We'll send you an invite when it's your turn.
        </Wrapper>
        <Wrapper margin="0.5rem">
          Looking to add your business to Pinmonkey? <Link to="/beta/host">Signup here</Link>.
        </Wrapper>
        {status === 'error' && (
          <Wrapper margin="0.5rem">
            Something went wrong. Please try again.
          </Wrapper>
        )}
        <FormInput
          label="Email"
          name="email"
          onChange={({ target: { value } }) => setEmail(value)}
          value={email}
          onKeyDown={handleKeyDown}
        />
        <Button className="large" onPress={submit}>
          Join waitlist
        </Button>
      </Card>
    </Layout>
  )
}

export * from './host'
